<div class="slide-header">
    <div class="title">
        <span class="points" [innerHTML]="teasedValue"></span>
        <span class="icon theme-info" (click)="showTeaserInfo()"></span>
        <bs-info-message-container [messageId]="teaserBetPointMessageId">
            <bs-digital-betslip-info [messages]="betslipInfoMessage" (close)="closeInfoBox()" />
        </bs-info-message-container>
    </div>
</div>
<div class="slide-content">
    <div class="slider-button" (click)="teasePoints(false)"><i class="theme-minus"></i></div>
    <div class="points-slider">
        <ms-slider
            [minIconTemplate]="iconTemplate"
            [steps]="steps"
            [range]="false"
            [stepId]="sliderStepId"
            [rangeVisible]="false"
            [highlightHandle]="true"
            (valueChange)="onPointChange($event)"
            [(value)]="sliderValue" />
    </div>
    <div class="slider-button" (click)="teasePoints(true)"><i class="theme-plus"></i></div>
</div>

<ng-template #iconTemplate>
    <span class="theme-arrow-down"></span>
</ng-template>
